export enum DeploymentTargetTaskType {
    Deployment = "Deployment",
    RunbookRun = "RunbookRun"
}
